import React, { useEffect, useState }  from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import classnames from 'classnames'

// styles
import useStyles from './styles'

// components
import Header from '../Header'

// pages
import Employees from '../../pages/employees'
import Reports from '../../pages/reports'
import Settings from '../../pages/settings'
import { useMasterState } from '../../context/MasterContext'
// context
import { useLayoutState } from '../../context/LayoutContext'
import { fetchMasterData, useMasterDispatch } from '../../context/MasterContext'
import { fetchCompanyData, useCompanyDispatch } from '../../context/CompanyContext'

const reportsDataChanged = {
	'CurrentAverageCostOfLaborDetail': false,
	'CurrentAverageCostOfLaborSummary': false,
	'ProjectedAverageCostOfLaborDetail': false,
	'ProjectedAverageCostOfLaborSummary': false,
	'PerformanceRatingOrgDetail': false,
	'PerformanceRatingOrgSummary': false,
	'PerformanceRatingAndCompaRatioDetail': false,
	'PerformanceRatingAndCompaRatioSummary': false,
	'OrganisationCompensation': false,
	'DepartmentalCompensation': false,
	'WorkforceCurrentHeadCountDetails': false,
	'WorkforceCurrentHeadCountSummary': false,
	'WorkforceProjectedHeadCountDetails': false,
}

function Layout(props) {
	let classes = useStyles()

	// global
	let layoutState = useLayoutState()
	let { masterData } = useMasterState()
	var companyDispatch = useCompanyDispatch()

	const masterDataDispatch = useMasterDispatch()
	const [reportDataChanged, setReportDataChanged] = useState(reportsDataChanged)
	// const companyDataDispatch = useCompanyDispatch()

	useEffect(() => {
		fetchMasterData(masterDataDispatch)
		fetchCompanyData(companyDispatch)
	}, [companyDispatch, masterDataDispatch])

	useEffect(() => {
		if(localStorage.getItem('reportDataChanged') !== null){
			let newReportDataChanged = JSON.parse(localStorage.getItem('reportDataChanged'))
			setReportDataChanged(newReportDataChanged)
		}
	}, [])

	const dataChanged = () => {
		let newReportDataChanged = {...reportDataChanged}
		Object.keys(newReportDataChanged).forEach(value => {
			newReportDataChanged[value] = true
		})
		setReportDataChanged(newReportDataChanged)
		localStorage.setItem('reportDataChanged', JSON.stringify(newReportDataChanged))
	}
	
	const onReportDataChanged = componentName => {
		let newReportDataChanged = {...reportDataChanged}
		newReportDataChanged[componentName] = false
		setReportDataChanged(newReportDataChanged)
		localStorage.setItem('reportDataChanged', JSON.stringify(newReportDataChanged))
	}

	return (

		<div className={classes.root}>
			<>
				<Header history={props.history} />
				<div
					className={classnames(classes.content, {
						[classes.contentShift]: layoutState.isSidebarOpened,
					})}
				>
					<div className={classes.fakeToolbar} />
					<Switch>
						<Route
							path="/app/employees"
							render={(props) => <Employees {...props} dataChanged={dataChanged} masterData={masterData} />}
						/>
						<Route
							path="/app/reports"
							render={(props) => <Reports {...props} onReportDataChanged={onReportDataChanged} reportDataChanged={reportDataChanged} masterData={masterData} />}
						/>
						<Route
							path="/app/settings"
							render={(props) => <Settings {...props} masterData={masterData} />}
						/>
					</Switch>
				</div>
			</>
		</div>
	)
}

export default withRouter(Layout)
